import * as React from 'react';

function SvgTemperature(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 11.92 23.97" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M6.56 15.66V9a.6.6 0 00-.6-.6.59.59 0 00-.59.6v6.67a2.38 2.38 0 101.19 0zm3.57-1.93V4.19a4.17 4.17 0 10-8.34 0v9.54A5.93 5.93 0 00-.02 18a6 6 0 1011.92 0 5.93 5.93 0 00-1.77-4.27zm-4.15 7.84a3.59 3.59 0 01-1.79-6.69V4.19a1.79 1.79 0 113.58 0v10.69a3.59 3.59 0 01-1.79 6.69z" />
    </svg>
  );
}

const MemoSvgTemperature = React.memo(SvgTemperature);
export default MemoSvgTemperature;
